import Vue from 'vue'
import VueRouter from 'vue-router'
import GoogleMap from '../components/GoogleMap'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'GoogleMap',
    component: GoogleMap
  },

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
